import React, {FC} from 'react';
import styled from 'styled-components';

import {
  LocalApplicationFeaturesEnum,
  LocalApplicationModel,
} from '../../../../../models/api/localApplicationModel';
import {SettingsDevelopersApplicationFeaturesUrl} from '../../../../../models/url/settingsUrlModel';
import {SettingsDevelopersApplicationFeatureChannelContainer} from './channel/settingsDevelopersApplicationFeatureChannelContainer';
import {DevelopersApplicationFeatureInboxSidePanelEntryPointContainer} from './entryPoints/developersApplicationFeatureInboxSidePanelEntryPointContainer';
import {SettingsDevelopersApplicationFeatureCard} from './settingsDevelopersApplicationFeatureCard';

/*
 * Props.
 */

interface SettingsDevelopersApplicationFeaturesPageProps {
  url: SettingsDevelopersApplicationFeaturesUrl;
  application: LocalApplicationModel;
}

/*
 * Style.
 */

const StyledFeaturesWrapperDiv = styled.div`
  flex: 1;
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
  gap: 24px;
  height: fit-content;
`;

/*
 * Component.
 */

export const SettingsDevelopersApplicationFeaturesPage: FC<SettingsDevelopersApplicationFeaturesPageProps> = (
  props,
) => {
  const {application, url} = props;
  switch (url.feature || '') {
    case LocalApplicationFeaturesEnum.INBOX_SIDEPANEL:
      return <DevelopersApplicationFeatureInboxSidePanelEntryPointContainer application={application} />;
    case LocalApplicationFeaturesEnum.CHANNEL:
      return <SettingsDevelopersApplicationFeatureChannelContainer application={application} />;
    default:
      return (
        <StyledFeaturesWrapperDiv>
          <SettingsDevelopersApplicationFeatureCard
            feature={LocalApplicationFeaturesEnum.INBOX_SIDEPANEL}
            application={application}
          />
          <SettingsDevelopersApplicationFeatureCard
            feature={LocalApplicationFeaturesEnum.CHANNEL}
            application={application}
          />
        </StyledFeaturesWrapperDiv>
      );
  }
};
